import React from "react";
import { Link, useHistory } from "react-router-dom";

const Breadcrumb = () => {
  const history = useHistory();

  const logoutHandler = () => {
    localStorage.removeItem("authToken");
    history.push("/auth/login");
  };

  return (
    <div className="flex p-3">
      <nav className="rounded-md w-[80%]">
        <ol className="flex">
          <li>
            <Link
              to="/auth/login"
              className="text-lg text-gray-600 hover:text-blue-700"
            >
              Login
            </Link>
          </li>
          <li>
            <span className=" text-gray-600 mx-2">/</span>
          </li>
          <li>
            <Link
              to="/contactus"
              className="hidden sm:block text-lg text-gray-600 hover:text-blue-700"
            >
              Contact Us
            </Link>
          </li>
          <li>
            <span className="hidden sm:block text-gray-500 mx-2">/</span>
          </li>
          <Link
            to="/trackorder"
            className="hidden sm:block text-lg text-gray-600 hover:text-blue-700"
          >
            Track your order
          </Link>
          <span className="hidden sm:block text-gray-500 mx-2">/</span>
          <button onClick={logoutHandler} className="text-lg text-red-600">
            Logout
          </button>
        </ol>
      </nav>
      <div className="flex pr-14 text-xl font-bold right sm:block">
        To see. To hear. To live.
      </div>
    </div>
  );
};

export default Breadcrumb;
